interface LabScoreBarProps {
  label: string
  score: number
}

export const LabScoreBar = ({ label, score }: LabScoreBarProps) => {
  const percentage = Math.max(0, Math.min(100, (score / 5) * 100))

  return (
    <div className="flex items-center gap-3">
      <span title={label} className="w-28 shrink-0 truncate text-sm text-white/75 sm:w-32">
        {label}
      </span>
      <span className="h-1.5 flex-1 overflow-hidden rounded-full bg-white/12" aria-hidden>
        <span className="bg-sky-80 block h-full rounded-full" style={{ width: `${percentage}%` }} />
      </span>
      <span className="text-md w-8 text-right font-semibold text-white tabular-nums">{score.toFixed(1)}</span>
    </div>
  )
}
